(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gdc-breed-finder"] && !Shopify.designMode) return;
  try {
    
(function () {
  const input = document.getElementById('gdcBreedSearch');
  const grid = document.getElementById('gdcBreedGrid');
  const empty = document.getElementById('gdcBreedEmpty');
  if (!input || !grid) return;
  const chips = Array.from(grid.querySelectorAll('.gdc-chip'));
  input.addEventListener('input', function () {
    const q = input.value.trim().toLowerCase();
    let shown = 0;
    chips.forEach(function (chip) {
      const match = !q || (chip.dataset.keys || '').indexOf(q) !== -1;
      chip.hidden = !match;
      if (match) shown++;
    });
    if (empty) empty.hidden = shown !== 0;
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
